import z from "zod";
import { COST_CALCULATION_TYPE } from "@miplatform/constants";

export const addCategoriesSchema = z
  .object({
    name: z.string().min(1, "Category name is required."),
    imageRequired: z.boolean(),
    linkedMaterials: z
      .array(
        z.object({
          materialId: z.string().uuid(),
          quantity: z.union([
            z.string().min(1, "Quantity can't be empty."),
            z.number().min(1, "Quantity can't be empty."),
          ]),
        })
      )
      .optional(),
    attributes: z
      .array(
        z.object({
          name: z.string().max(32),
          isRequired: z.boolean(),
          displayOrder: z.number(),
        })
      )
      .superRefine((items, ctx) => {
        const uniqueValues = new Map();
        items.forEach((item, index) => {
          const firstIndex = uniqueValues.get(item.name.toLowerCase());
          if (firstIndex !== undefined) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: `Attribute name must be unique`,
              path: [index, "name"],
            });
            return;
          }
          uniqueValues.set(item.name.toLowerCase(), index);
        });
      }),
    displayOrder: z.coerce
      .number({
        invalid_type_error: "Display order must be a number",
      })
      .int()
      .nonnegative()
      .nullable()
      .optional(),
    itemCodeNumberPattern: z.string().optional(),
    itemDescriptionPattern: z.string(),
    dropRequired: z.boolean().optional(),
    costCalculation: z.enum([
      COST_CALCULATION_TYPE.NET_COST,
      COST_CALCULATION_TYPE.LIST,
    ]),
    multiplier: z
      .number()
      .min(0.01, "Multiplier must be greater than or equal to 0.01")
      .max(1, "Multiplier must be less than or equal to 1")
      .optional(),
  })
  .refine(
    (data) => {
      if (
        data.costCalculation === COST_CALCULATION_TYPE.LIST &&
        !data.multiplier
      ) {
        return false;
      }
      return true;
    },
    {
      message: "Multiplier is required",
      path: ["multiplier"],
    }
  );
